// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const OfferingRegistrationCollection =
  require("library/models/offering-registration-collection").default
const OfferingRegistration =
  require("library/models/offering-registration").default
import {
  ENROLLMENT_ROLE_FACILITATOR,
  ENROLLMENT_ROLE_OBSERVER,
  ENROLLMENT_ROLE_STUDENT,
  ENROLLMENT_ROLE_TEACHER
} from "@pathwright/web/src/modules/invitation/constants"

const OFFERING_ROLE_LABELS = {
  [ENROLLMENT_ROLE_OBSERVER]: "observer",
  [ENROLLMENT_ROLE_STUDENT]: "student",
  [ENROLLMENT_ROLE_FACILITATOR]: "moderator",
  [ENROLLMENT_ROLE_TEACHER]: "teacher"
}

class MemberStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store").default
) {
  static initClass() {
    this.prototype.resources = {
      members: {
        collection: OfferingRegistrationCollection
      },
      facilitators: {
        collection: OfferingRegistrationCollection
      }
    }

    this.prototype.storeTriggerHandlers = {
      resource: {
        "change:offering"() {
          const { offering } = this.getStore("resource").getState()
          const nextOffering = offering != null ? offering.id : undefined
          const thisOffering = __guard__(
            this.get("facilitators"),
            (x) => x.options.offering_id
          )
          if (nextOffering !== thisOffering) {
            return this.action.loadFacilitatorsForOffering(offering)
          }
        }
      }
    }

    this.prototype.syncStores = {
      resource: ["resource", "offering", "registration"]
    }

    this.prototype.actions = {
      loadFacilitatorsForOffering(offering, forceReload) {
        if (forceReload == null) {
          forceReload = false
        }
        if (!offering) {
          return
        }
        const params = this.request.getFacilitatorParams(offering)
        if (params) {
          return this.resource.facilitators.list(params, forceReload)
        }
      },

      clearFacilitators() {
        return this._mutate({ facilitators: null })
      },

      loadMembers(forceReload) {
        if (forceReload == null) {
          forceReload = false
        }
        const params = this.request.getMemberParams()
        if (params) {
          return this.resource.members.list(params, forceReload)
        }
      },

      clearMembers() {
        this.resource.members.clearCache()
      },

      changeMembersQuery(members_query) {
        if (members_query === "") {
          return this.action.clearMembersQuery()
        } else {
          return this._mutate({ members_query })
        }
      },

      clearMembersQuery() {
        this._mutate({ members_query: "" })
        return this.action.searchMembers()
      },

      searchMembers(forceReload) {
        if (forceReload == null) {
          forceReload = false
        }
        const params = this.request.getMemberParams()
        this._mutate({ members_query_loading: true })
        return this.resource.members.list(params, forceReload).then(() => {
          return this._mutate({ members_query_loading: false })
        })
      },

      sortMembers(members_ordering) {
        this._mutate({ members_ordering })
        return this.action.loadMembers()
      },

      reorderMembers(members_descending) {
        this._mutate({ members_descending })
        return this.action.loadMembers()
      },

      loadMoreMembers() {
        const members = this.get("members")
        const loading = this.get("members_loading")

        if (!loading) {
          return new Promise(
            function (resolve, reject) {
              this._mutate({ members_loading: true })
              return members.next().then(() => {
                this._mutate({ members_loading: false })
                this.triggerChange("change:members")
                return resolve()
              })
            }.bind(this)
          )
        }
      },

      removeMember(user) {
        const { id } = user
        const offering_id = __guard__(
          window.App.getStore("resource").get("offering"),
          (x) => x.id
        )
        const member = new OfferingRegistration({ id, offering_id })
        return new Promise(
          function (resolve, reject) {
            return member
              .destroy()
              .then(() => {
                resolve()
                this.action.onMemberRemoved(id)
                return this._mutate({
                  member_removing: null
                })
              })
              .fail(reject)
          }.bind(this)
        )
      },

      onMemberRemoved(memberID) {
        const members = this.get("members")
        const facilitators = this.get("facilitators")

        // update members
        if (members != null ? members.get(memberID) : undefined) {
          this.resource.members.clearCache()
          members.remove(memberID)
          this.triggerChange("change:members")
          this.triggerChange("removed:member")
        }
        // update facilitators
        if (facilitators != null ? facilitators.get(memberID) : undefined) {
          this.resource.facilitators.clearCache()
          facilitators.remove(memberID)
          return this.triggerChange("change:facilitators")
        }
      },

      selectMemberForRemoval(id) {
        return this._mutate({ member_removing: id })
      },

      unselectMemberForRemoval() {
        return this._mutate({ member_removing: null })
      },

      filterRoleType(role_type) {
        if (role_type != this.get("role_type")) {
          this._mutate({ role_type })
          this.action.loadMembers(true)
        }
      },

      // Temporary hack for updating member's role in member's list (and likely elsewhere)
      respondToMemberRoleUpdate(member) {
        if (member && this.get("members")) {
          const m = this.get("members").get(member.id)
          const f = this.get("facilitators").get(member.id)
          if (m) m.set("role", member.role)
          if (f) f.set("role", member.role)

          // Remove member from facilitators list if role dips below Moderator.
          if (f && member.role < 10) {
            this.get("facilitators").remove(member.id)
          }

          // Add member from members list if role rises above Learner.
          if (m && !f && member.role >= 10) {
            this.get("facilitators").add(m)
          }
        }
      }
    }

    this.prototype.requests = {
      hasMoreMembers() {
        const members = this.get("members")
        return (members != null ? members.nextPage : undefined) > -1
      },

      getFacilitatorParams(offering) {
        const offering_id =
          (offering != null ? offering.id : undefined) ||
          __guard__(App.getStore("resource").get("offering"), (x) => x.id)
        if (!offering_id) {
          return null
        }
        return {
          offering_id,
          type: "moderator,teacher",
          expand: "user",
          ordering: "-role"
        }
      },

      getMemberParams() {
        const offering_id = __guard__(
          window.App.getStore("resource").get("offering"),
          (x) => x.id
        )
        const ordering_direction = this.get("members_descending") ? "-" : ""
        if (!offering_id) {
          return null
        }
        const { role_type } = this.getState()
        return {
          type: role_type
            ? OFFERING_ROLE_LABELS[role_type]
            : [
                OFFERING_ROLE_LABELS[ENROLLMENT_ROLE_OBSERVER],
                OFFERING_ROLE_LABELS[ENROLLMENT_ROLE_STUDENT],
                OFFERING_ROLE_LABELS[ENROLLMENT_ROLE_FACILITATOR]
              ].join(","),
          offering_id,
          page_size: 50,
          expand: "user,points",
          search: this.get("members_query") || null,
          ordering: `${ordering_direction}${this.get("members_ordering")}`
        }
      },

      getLastMemberQuery() {
        const members = this.get("members")
        return __guard__(
          members != null ? members.options : undefined,
          (x) => x.search
        )
      }
    }
  }

  defaults() {
    return {
      members_query: "",
      members_ordering: "progress",
      members_descending: true,
      members_query_loading: false,
      member_removing: null,
      member_selected_for_removal: null,
      role_type: null // defaulting to observer, student, and moderator
    }
  }

  bootstrapStore() {
    // Loadin the cohort staff if a bootstrapped offering is found.
    const offering = window.bootstrappedData?.offering
    if (offering) {
      this.action.loadFacilitatorsForOffering(offering)
    }
  }
}
MemberStore.initClass()

export default window.App.stores.registerStore("member", MemberStore)
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
